// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combo-picker {
  width: 5rem;
  height: 40px;
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
}
.combo-picker .place-holder {
  color: #605260;
  font-size: 13px;
  margin-left: 9px;
}
.combo-picker .front span {
  line-height: 40px;
}
.combo-picker .front .arrow {
  float: right;
  font-size: 14px;
  color: #5e0066;
  margin-right: 9px;
}
.combo-picker .dropdown-menu {
  max-width: 94px;
  min-width: 64px;
  max-height: 12rem;
  overflow-y: scroll;
  background-color: #FFFFFF;
  padding: 0;
  border-radius: 0px;
}
.combo-picker .dropdown-menu hr {
  margin: 0;
}
.combo-picker .drop-menu-item {
  padding: 0.4rem;
  cursor: pointer;
}
.combo-picker .drop-menu-item:hover {
  background-color: rgba(41, 187, 115, 0.1);
}

.invalid {
  border-color: red;
}

.disabled {
  background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/combo-picker/combo-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACJ;AAGI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AADR;AAKQ;EACI,iBAAA;AAHZ;AAMQ;EACI,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAJZ;AAQI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AANR;AAOQ;EACI,SAAA;AALZ;AASI;EACI,eAAA;EACA,eAAA;AAPR;AAQQ;EACE,yCAAA;AANV;;AAaA;EACI,iBAAA;AAVJ;;AAaA;EACI,2BAAA;AAVJ","sourcesContent":[".combo-picker {\n    width: 5rem;\n    height: 40px;\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC; // cursor: pointer;\n\n\n\n    .place-holder {\n        color: #605260;\n        font-size: 13px;\n        margin-left: 9px;\n    }\n\n    .front {\n        span {\n            line-height: 40px;\n        }\n\n        .arrow {\n            float: right;\n            font-size: 14px;\n            color: #5e0066;\n            margin-right: 9px;\n        }\n    }\n\n    .dropdown-menu {\n        max-width: 94px;\n        min-width: 64px;\n        max-height: 12rem;\n        overflow-y: scroll;\n        background-color: #FFFFFF;\n        padding: 0;\n        border-radius: 0px;\n        hr {\n            margin: 0;\n        }\n    }\n\n    .drop-menu-item {\n        padding: 0.4rem;\n        cursor: pointer;\n        &:hover {\n          background-color: rgba(41, 187, 115, 0.1)\n        }\n\n    }\n\n}\n\n.invalid {\n    border-color: red;\n}\n\n.disabled {\n    background-color: lightgray;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
